<app-download-app></app-download-app>
<div class="setup-pass-container">
    <app-setup-password-form [isQueue]="isQueue"></app-setup-password-form>
</div>

